import { createApp } from 'vue'
import $ from 'jquery'
import ShortcodeCourseTable from './components/shortcode_course_table'

const $programDropdown = $('#shortcode-programs-dropdown');

if ($programDropdown.length) {
  let programId = parseInt($programDropdown.val())
  let abbr = $programDropdown.find('option[value=' + programId + ']').data('abbr')

  $(document).on('ready', function() {
    if (programId > 0) {
      renderTable(programId, abbr);
    }
  });

  $programDropdown.on('change', function() {
    programId = parseInt($(this).val())
    abbr = $programDropdown.find('option[value=' + programId + ']').data('abbr')

    if (programId > 0) {
      $programDropdown.parent().after("<div id='shortcode-table-program-courses'></div>")
      renderTable(programId, abbr)
      setTimeout(() => { SOPHIA.stickyHeaderForTable() }, 500)
    } else {
      $programDropdown.parent().next('.course-table-wrapper').remove()
    }

    SOPHIA.clickToggleForGA({
      el: $programDropdown,
      eventAction: 'expand',
      moduleName: 'All Partner Institutions',
      fieldType: 'dropdown',
      clickText: $('option:selected', $programDropdown).text()
    })
  });

  const renderTable = function(id, abbreviation) {
    const xhrData = {
      url: '/courses_list/' + id,
      type: 'get',
      dataType: 'json'
    };

    const callbacks = {
      afterSuccess: function(resp) {
        $('.shortcode-programs-dropdown-wrapper .f-shortcode-courses-table').remove()
        createApp(ShortcodeCourseTable, { table: resp, abbr: abbreviation, toShowAbbr: programId != 2 }).mount('#shortcode-table-program-courses');
        SOPHIA.clickLinkForGA($('body.flexible-layout'));
      }
    };

    SOPHIA.sendXHR(xhrData, callbacks);
  }
}
